import { useInView } from 'framer-motion';
import { useRef } from 'react';

import AnimateNumber from '@/components/AnimateNumber';
import Text from '@/components/Text';

const metrics = [
  { value: 30, suffix: 's', label: 'From CAD file to itemized quote' },
  { value: 90, suffix: '%', label: 'Faster than manual quoting' },
  {
    value: 2,
    prefix: '±',
    suffix: '%',
    label: 'Pricing consistency, every estimator',
  },
  {
    value: 250,
    suffix: '+',
    label: 'Businesses building business with MindPal',
  },
];

const CncRfqMetrics = () => {
  const viewportRef = useRef<HTMLDivElement>(null);
  const inView = useInView(viewportRef, {
    amount: 1,
    once: true,
    margin: '-10% 0px -10% 0px',
  });

  return (
    <div className="grid w-full grid-cols-2 gap-8 md:grid-cols-4 md:gap-10">
      {metrics.map(({ value, prefix, suffix, label }) => (
        <div
          key={label}
          className="flex flex-col gap-4 border-t border-neutral-700 pt-4"
        >
          <AnimateNumber
            ref={viewportRef}
            value={inView ? value : 0}
            className="text-jb-primary-400"
            variant="display-3"
            prefixElement={
              prefix ? (
                <Text className="text-jb-primary-400" variant="display-3">
                  {prefix}
                </Text>
              ) : undefined
            }
            suffixElement={
              <Text className="text-jb-primary-400" variant="display-3">
                {suffix}
              </Text>
            }
          />
          <Text className="!text-md text-jb-neutral-400 md:!text-lg lg:!text-xl">
            {label}
          </Text>
        </div>
      ))}
    </div>
  );
};

export default CncRfqMetrics;
